/**
 * Auto time-period label from Required From → Required Till (ISO yyyy-mm-dd).
 * Uses calendar years / months / days (exact parts, omit zeros).
 */

function parseIsoDate(iso) {
  if (!iso || !/^\d{4}-\d{2}-\d{2}$/.test(iso)) return null;
  const [y, m, d] = iso.split('-').map(Number);
  return new Date(y, m - 1, d);
}

function plural(n, unit) {
  return `${n} ${unit}${n === 1 ? '' : 's'}`;
}

/**
 * @returns {string} e.g. "3 Months", "1 Year 2 Months", "15 Days", or ""
 */
export function formatTimePeriod(fromIso, tillIso) {
  const from = parseIsoDate(fromIso);
  const till = parseIsoDate(tillIso);
  if (!from || !till) return '';
  if (till < from) return '';

  let years = till.getFullYear() - from.getFullYear();
  let months = till.getMonth() - from.getMonth();
  let days = till.getDate() - from.getDate();

  if (days < 0) {
    months -= 1;
    const daysInPrevMonth = new Date(till.getFullYear(), till.getMonth(), 0).getDate();
    days += daysInPrevMonth;
  }
  if (months < 0) {
    years -= 1;
    months += 12;
  }

  // Same calendar day → treat as 1 Day hire window
  if (years === 0 && months === 0 && days === 0) return plural(1, 'Day');

  const parts = [];
  if (years > 0) parts.push(plural(years, 'Year'));
  if (months > 0) parts.push(plural(months, 'Month'));
  if (days > 0) parts.push(plural(days, 'Day'));
  return parts.join(' ');
}
